import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';

// Import service images
import ProjectAnalysisImage from '../assets/services/ProjectAnalysis.png';
import ProjectStructuringImage from '../assets/services/ProjectStructuring.png';
import TreasuryBundleImage from '../assets/services/TreasuryBundle.png';
import WorkOutPlansImage from '../assets/services/WorkOutPlans.png';

const Services = () => {
  const servicesData = [
    {
      heading: 'Project Analysis',
      body: 'We adopt novel techniques to due diligence that uniquely identify emerging trends, market conditions, and potential project risks and opportunities.',
      image: ProjectAnalysisImage,
    },
    {
      heading: 'Project Structuring',
      body: 'We provide bespoke structures for real estate financings that align interests and optimize stakeholder value.',
      image: ProjectStructuringImage,
    },
    {
      heading: 'Treasury Bundle',
      body: 'We offer developers a streamlined approach to managing liquidity, debt, solvency, and capital – all from one easy-to-use platform.',
      image: TreasuryBundleImage,
    },
    {
      heading: 'Work Out Plans',
      body: 'We strategically re-evaluate and analyze underperforming real estate investments to develop workout plans that bring them back on track to success.',
      image: WorkOutPlansImage,
    },
  ];

  return (
    <section
      id="services"
      className="
        w-full
        min-h-screen
        flex flex-col justify-center
        overflow-hidden
        md:block
      "
    >
      <Swiper
        modules={[Pagination, Autoplay]}
        spaceBetween={50}
        slidesPerView={1}
        autoplay={{ delay: 5000 }}
        pagination={{ clickable: true }}
        loop={true}
        className="w-full h-full"
      >
        {servicesData.map((service, index) => (
          <SwiperSlide key={index}>
            {/* Mobile: auto height + centered by parent. Desktop: full‑screen row */}
            <div className="flex flex-col-reverse md:flex-row h-auto md:h-screen">
              
              {/* Text panel */}
              <div className="w-full md:w-1/2 flex flex-col justify-center p-6 md:p-20 md:bg-lavender">
                <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-ubuntu text-electricViolet mb-4">
                  {service.heading}
                </h1>
                <p
                  className="text-lg md:text-2xl lg:text-3xl font-light font-merriweather text-deepIndigo"
                  style={{ lineHeight: '1.5' }}
                >
                  {service.body}
                </p>
              </div>

              {/* Image panel */}
              <div className="w-full md:w-1/2 flex justify-center items-center p-6">
                <img
                  src={service.image}
                  alt={`${service.heading} Visual`}
                  className="max-h-[100%] max-w-[100%] object-contain"
                />
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default Services;
